module.exports = {
  message: {
    service_desc: '透過此工具來轉換 COS 代幣的格式，包括<strong>主網原生 COS、BEP2、ERC-20、BEP-20</strong>',
    choose_token_type: '代幣轉換方向',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => 主網原生 COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => 主網原生 COS',
    token_type_native_to_erc20: '主網原生 COS => ERC-20',
    token_type_native_to_bep2: '主網原生 COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => 主網原生 COS',
    token_type_native_to_bep20: '主網原生 COS => BEP-20',
    enter_address: '轉換目的帳號/地址',
    enter_exchange_memo: 'Memo（檢測到目的地址為交易所，請填入交易所提供的 Memo 以確保順利接收 COS 代幣）',
    create_account_tips: '沒有帳號嗎？馬上創建',
    next_btn: '下一步',
    start_over_btn: '重新開始',
    ready_to_swap: '準備好進行代幣轉換',
    transfer_prefix: '將你的 {token} 轉帳到',
    address: '帳號/地址',
    memo: 'MEMO',
    auto_swap_desc: '請確保轉帳到正確的帳號/地址，代幣轉換工具收到轉帳後，' +
      '會將相應的代幣數量轉入指定的目的錢包。<strong>（此過程約需五分鐘）<strong>',
    auto_swap_desc_memo: '請確保轉帳到正確的帳號/地址並附帶上述 MEMO，代幣轉換工具收到轉帳後，' +
      '會將相應的代幣數量轉入指定的目的錢包。<strong>（此過程約需五分鐘）<strong>',
    main_net_address: 'Contentos 主網帳號',
    bep2_address: 'BEP2 錢包地址',
    erc20_address: 'ERC-20 錢包地址',
    bep20_address: 'BEP-20 錢包地址',
    main_net_token: '主網原生 COS',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: '確定',
    Cancel: '取消',
    tips: '提示',
    enter_address_tips: '請輸入正確的地址',
    enter_exChange_memo_tips: '請輸入正確的 Memo',
    swap_address_invalid: '此地址不符合規範',
    swap_address_not_exit: '此帳號不存在',
    swap_type_invalid: '無效的代幣轉換方向',
    swap_system_error: '系統錯誤，請稍後再試',
    swap_unknown_error: '發生未知問題，請稍後再試',
    swap_memo_invalid: 'Memo不符合規範',
    invalid_bnb_exChange_memo_tips: '幣安交易所Memo必須是數字',
    paste_warning: '將地址貼上時，請確認與複製的內容相符',
    fee_notice: '請注意：每筆{token}轉換將收取{fee} COS手續費以支應帳戶轉帳的gas費用，不足{fee} COS的轉換將不會被處理。',
    fee_subject_to_change: '手續費可能變動且不另行通知'
  }
}
